import { Select, SelectProps } from '@chakra-ui/react';
import React from 'react';

export const CmSelect: React.FC<SelectProps> = ({
  children,
  bg = 'white',
  ...rest
}) => {
  // @ts-ignore TS2590
  return <Select {...{ bg, ...rest }}>{children}</Select>;
};
